module.exports = "/assets/paywall-main.webp"